import MyContactInformationService from '@/profile/my-contact-information/services/my-contact-information.service';

export default class RepContactForm {
  billing: {
    postal: string;
    street: string[];
    city: string;
    county: string;
    state: string;
    country: string;
  };
  shipping: {
    postal: string;
    street: string[];
    city: string;
    county: string;
    state: string;
    country: string;
  };
  phone: string[];
  email: string;

  constructor(data: any) {
    this.billing = data.billing;
    this.shipping = data.shipping;
    this.phone = data.phone;
    this.email = data.email;
  }

  hasAtLeastOnePhone() {
    return this.phone.some((phone) => phone !== '');
  }

  hasBillingPostalCode() {
    return this.billing.postal !== '';
  }

  hasBillingStreet() {
    return this.billing.street[0] !== '' || this.billing.street[1] !== '';
  }

  hasBillingCity() {
    return this.billing.city !== '';
  }

  hasBillingCounty() {
    return this.billing.county !== '';
  }

  hasBillingState() {
    return this.billing.state !== '';
  }

  hasShippingPostalCode() {
    return this.shipping.postal !== '';
  }

  hasShippingStreet() {
    return this.shipping.street[0] !== '' || this.shipping.street[1] !== '';
  }

  hasShippingCity() {
    return this.shipping.city !== '';
  }

  hasShippingCounty() {
    return this.shipping.county !== '';
  }

  hasShippingState() {
    return this.shipping.state !== '';
  }

  validEmail() {
    return MyContactInformationService.isValidEmail(this.email);
  }

  hasRequiredData() {
    const hasBillingIfo = this.hasBillingCity() && (this.billing.country !== 'USA' || this.hasBillingCounty())
        && this.hasBillingPostalCode() && this.hasBillingStreet() && this.hasBillingState();
    const hasShippingInfo = this.hasShippingCity() && (this.shipping.country !== 'USA' || this.hasShippingCounty())
        && this.hasShippingPostalCode() && this.hasShippingStreet() && this.hasShippingState();
    return hasBillingIfo && hasShippingInfo && this.hasAtLeastOnePhone() && this.validEmail() && this.phone[0] !== '';
  }
}
